import { ChildBMIThreshold, Gender } from './healthTypes';

export const CHILD_BMI_STANDARDS: ChildBMIThreshold[] = [
  { age: 7, gender: Gender.Male, malnutrition: 13.9, overweight: 17.4, obesity: 19.2 },
  { age: 8, gender: Gender.Male, malnutrition: 14.0, overweight: 18.1, obesity: 20.3 },
  { age: 9, gender: Gender.Male, malnutrition: 14.1, overweight: 18.9, obesity: 21.4 },
  { age: 10, gender: Gender.Male, malnutrition: 14.4, overweight: 19.6, obesity: 22.5 },
  { age: 11, gender: Gender.Male, malnutrition: 14.7, overweight: 20.3, obesity: 23.6 },
  { age: 12, gender: Gender.Male, malnutrition: 15.1, overweight: 21.0, obesity: 24.7 },
  { age: 13, gender: Gender.Male, malnutrition: 15.5, overweight: 21.9, obesity: 25.7 },
  { age: 14, gender: Gender.Male, malnutrition: 16.0, overweight: 22.6, obesity: 26.4 },
  { age: 15, gender: Gender.Male, malnutrition: 16.5, overweight: 23.1, obesity: 26.9 },
  { age: 16, gender: Gender.Male, malnutrition: 17.0, overweight: 23.5, obesity: 27.4 },
  { age: 17, gender: Gender.Male, malnutrition: 17.5, overweight: 23.8, obesity: 27.8 },
  { age: 18, gender: Gender.Male, malnutrition: 17.9, overweight: 24.0, obesity: 28.0 },

  { age: 7, gender: Gender.Female, malnutrition: 13.5, overweight: 17.2, obesity: 18.9 },
  { age: 8, gender: Gender.Female, malnutrition: 13.7, overweight: 18.1, obesity: 19.9 },
  { age: 9, gender: Gender.Female, malnutrition: 13.9, overweight: 19.0, obesity: 21.0 },
  { age: 10, gender: Gender.Female, malnutrition: 14.2, overweight: 20.0, obesity: 22.3 },
  { age: 11, gender: Gender.Female, malnutrition: 14.6, overweight: 21.1, obesity: 23.7 },
  { age: 12, gender: Gender.Female, malnutrition: 15.0, overweight: 21.9, obesity: 25.0 },
  { age: 13, gender: Gender.Female, malnutrition: 15.6, overweight: 22.6, obesity: 26.0 },
  { age: 14, gender: Gender.Female, malnutrition: 16.2, overweight: 23.0, obesity: 26.6 },
  { age: 15, gender: Gender.Female, malnutrition: 16.7, overweight: 23.4, obesity: 26.9 },
  { age: 16, gender: Gender.Female, malnutrition: 17.2, overweight: 23.7, obesity: 27.1 },
  { age: 17, gender: Gender.Female, malnutrition: 17.6, overweight: 23.8, obesity: 27.3 },
  { age: 18, gender: Gender.Female, malnutrition: 18.0, overweight: 24.0, obesity: 28.0 },
];

export const ADULT_BMI_STANDARDS = {
  underweight: 18.5,
  overweight: 24.0,
  obesity: 28.0,
};

export const GROWTH_STANDARDS = {
  male: {
    height: [
      { age: 7, p3: 116.6, p50: 124.0, p97: 131.4 },
      { age: 8, p3: 121.6, p50: 129.3, p97: 137.0 },
      { age: 9, p3: 126.5, p50: 134.5, p97: 142.5 },
      { age: 10, p3: 131.4, p50: 139.6, p97: 148.0 },
      { age: 11, p3: 136.0, p50: 145.3, p97: 154.5 },
      { age: 12, p3: 141.0, p50: 151.9, p97: 162.8 },
      { age: 13, p3: 147.5, p50: 159.5, p97: 171.5 },
      { age: 14, p3: 153.5, p50: 165.5, p97: 177.5 },
      { age: 15, p3: 158.0, p50: 169.8, p97: 181.6 },
      { age: 16, p3: 160.5, p50: 172.5, p97: 184.5 },
      { age: 17, p3: 161.8, p50: 173.9, p97: 186.0 },
      { age: 18, p3: 162.5, p50: 174.5, p97: 186.5 },
    ],
    weight: [
      { age: 7, p3: 20.2, p50: 24.1, p97: 33.0 },
      { age: 8, p3: 22.2, p50: 27.2, p97: 38.5 },
      { age: 9, p3: 24.3, p50: 30.5, p97: 45.0 },
      { age: 10, p3: 26.8, p50: 34.0, p97: 51.5 },
      { age: 11, p3: 29.5, p50: 38.5, p97: 59.0 },
      { age: 12, p3: 32.5, p50: 44.0, p97: 68.0 },
      { age: 13, p3: 36.0, p50: 50.0, p97: 76.0 },
      { age: 14, p3: 40.0, p50: 55.0, p97: 82.0 },
      { age: 15, p3: 44.0, p50: 59.0, p97: 86.0 },
      { age: 16, p3: 47.0, p50: 62.0, p97: 89.0 },
      { age: 17, p3: 49.0, p50: 64.0, p97: 91.5 },
      { age: 18, p3: 50.0, p50: 65.0, p97: 93.0 },
    ]
  },
  female: {
    height: [
      { age: 7, p3: 115.1, p50: 122.5, p97: 129.9 },
      { age: 8, p3: 120.4, p50: 128.5, p97: 136.6 },
      { age: 9, p3: 125.7, p50: 134.2, p97: 142.7 },
      { age: 10, p3: 131.0, p50: 140.1, p97: 149.2 },
      { age: 11, p3: 136.5, p50: 146.5, p97: 156.4 },
      { age: 12, p3: 142.0, p50: 152.4, p97: 162.8 },
      { age: 13, p3: 146.0, p50: 156.3, p97: 166.6 },
      { age: 14, p3: 148.5, p50: 158.5, p97: 168.5 },
      { age: 15, p3: 150.0, p50: 159.8, p97: 169.6 },
      { age: 16, p3: 150.8, p50: 160.5, p97: 170.2 },
      { age: 17, p3: 151.2, p50: 160.9, p97: 170.6 },
      { age: 18, p3: 151.5, p50: 161.2, p97: 171.0 },
    ],
    weight: [
      { age: 7, p3: 19.5, p50: 22.9, p97: 30.6 },
      { age: 8, p3: 21.4, p50: 25.8, p97: 35.8 },
      { age: 9, p3: 23.4, p50: 29.0, p97: 41.5 },
      { age: 10, p3: 25.6, p50: 32.5, p97: 48.0 },
      { age: 11, p3: 28.0, p50: 36.5, p97: 55.0 },
      { age: 12, p3: 31.0, p50: 41.0, p97: 62.0 },
      { age: 13, p3: 34.5, p50: 45.5, p97: 67.5 },
      { age: 14, p3: 38.0, p50: 49.0, p97: 71.5 },
      { age: 15, p3: 40.5, p50: 51.5, p97: 74.0 },
      { age: 16, p3: 42.0, p50: 53.0, p97: 76.0 },
      { age: 17, p3: 43.0, p50: 54.0, p97: 77.5 },
      { age: 18, p3: 44.0, p50: 55.0, p97: 78.5 },
    ]
  }
};
